import React, { useContext } from 'react';
import { Typography, Box } from 'vindi-ds-components';
import { AdminContext } from '@contexts/admin_context';
import TitleContainer from '../../containers/title_container';

function Title({ isCompleted }) {
  const { name } = useContext(AdminContext);

  return (
    <TitleContainer>
      <Box mb={{ xs: '0em', md: '0em' }}>
        <Box mb='0.5em'>
          <Typography variant='h4' component='h2' style={{ color: '#4D4D4D', lineHeight: '48px', fontSize: '32px' }}>
            Olá, {name}!
          </Typography>
        </Box>
        {
          !isCompleted && (
            <>
              <Box mb='0.5em'>
                <Typography variant='body1'>
                  Este é um ambiente de testes e estamos aqui para te ajudar durante sua jornada.
                  Você pode explorar a plataforma por conta própria ou seguir nossas instruções.
                  Lembrando que a criação de produto, plano e cliente são configurações básicas para
                  testar a plataforma
                </Typography>
              </Box>
              <Typography variant='subtitle1' weight='medium'>
                Configurações básicas
              </Typography>
            </>
          )
        }
      </Box>
    </TitleContainer>
  );
}

export default Title;
